import IUser from "@myinnsworth/models/user/IUser";
import HttpServiceBase, { AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../httpServiceBase";
import ISignInResultModel from "./models/ISignInResultModel";
import { IBeginPasswordResetModel } from "./models/IBeginPasswordResetModel";
import { IResetPasswordModel } from "./models/IResetPasswordModel";
import { IRegisterContactModel } from "./models/IRegisterContactModel";
import { IChangePasswordModel } from "./models/IChangePasswordModel";
import axios from "axios";

export const AuthenticationMessages: any = {
    SIGN_IN_PROGRESS_MESSAGE: 'signing-in',
    SIGN_IN_SUCCESS_MESSAGE: 'signin',
    SIGNED_OUT_MESSAGE: 'signout'
};

class AuthenticationHttpService extends HttpServiceBase {
    protected get serviceName(): string { return 'auth' };

    public get isAuthenticated(): boolean {
        return !!localStorage.getItem(AUTH_TOKEN_KEY) || !!localStorage.getItem(REFRESH_TOKEN_KEY);
    }

    private logout() {
        localStorage.removeItem(AUTH_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    }

    public async signIn(email: string, password: string, rememberMe: boolean): Promise<IUser> {
        try {
            //this.emit(AuthenticationMessages.SIGN_IN_PROGRESS_MESSAGE, 'login');
            const result = await this.typedPost<ISignInResultModel>(`signin`, { email, password, rememberMe });
            if(result.user) {
               this.emit(AuthenticationMessages.SIGN_IN_SUCCESS_MESSAGE, result);
            }
            return result.user;
        } catch(ex) {
            this.logout();
            //this.emit(AuthenticationMessages.SIGNED_OUT_MESSAGE);
            return Promise.reject(ex);
        }
    }

    public async signInWithToken(): Promise<IUser> {
        try {
            this.emit(AuthenticationMessages.SIGN_IN_PROGRESS_MESSAGE, 'token');
            const result = await this.typedGet<ISignInResultModel>(`token/refresh`, { token: localStorage.getItem(REFRESH_TOKEN_KEY) });
            if(result.user) {
                this.emit(AuthenticationMessages.SIGN_IN_SUCCESS_MESSAGE, result);
            }
            return result.user;
        } catch(ex) {
            this.logout();
            this.emit(AuthenticationMessages.SIGNED_OUT_MESSAGE);
            return Promise.reject(ex);
        }
    }

    public async signOut(): Promise<any> {
        this.logout();
        await this.post(`signout`);
        this.emit(AuthenticationMessages.SIGNED_OUT_MESSAGE);
    }

    public async beginPasswordReset(model: IBeginPasswordResetModel): Promise<any> {
        await this.post(`password/forgot`, model);
    }

    public async validateResetPasswordToken(token: string): Promise<boolean> {
        let isValid: boolean = false;
        try {
            await this.get(`password/forgot/${token}`);
            isValid = true;     //Any success response means valid
        }
        catch {
            isValid = false;
        }
        return isValid;
    }
    
    public async confirmRegistration(token: string): Promise<boolean> {
        let isValid: boolean = false;
        try {
            await this.put(`register/${token}`);
            isValid = true;     //Any success response means valid
        }
        catch {
            isValid = false;
        }
        return isValid;
    }
    public async resetPassword(model: IResetPasswordModel): Promise<any> {
        await this.post(`password/forgot/${model.token}`, model);
    }

    public async registerContact(model: IRegisterContactModel): Promise<any> {
        await this.post(`register`, model);
    }

    public async changePassword(model: IChangePasswordModel): Promise<any> {
        await this.post(`password/change`, model);
    }
}

const service = new AuthenticationHttpService();

axios.interceptors.response.use(response => {
    const token = response.headers['x-auth-token'];
    if(token) {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    }

    const refreshToken = response.headers['x-auth-refresh-token'];
    if(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }

    return response; 
}, async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401) {
        //If we get a 401 from token refresh, then the refresh token is invalid, so we sign out
        if(originalRequest._retry || originalRequest.url.toLowerCase().includes('token/refresh')) {
            //service.signOut();
            return Promise.reject(error);
        } else {
            originalRequest._retry = true;
            //originalRequest.headers = {};
            console.log('Got an auth issue, refreshing!');
            try {
                await service.signInWithToken();
            } catch {
                service.signOut();
            }
            return axios(originalRequest);
        }
    }
    return Promise.reject(error);
});

// axios.interceptors.response.use(response => response, async function (error) {
//     const originalRequest = error.config;
//     if (error.response.status === 401) {
//         //If we get a 401 from token refresh, then the refresh token is invalid, so we sign out
//         if(originalRequest._retry || originalRequest.url.toLowerCase().includes('token/refresh')) {
//             service.signOut();
//             return Promise.reject(error);
//         } else {
//             originalRequest._retry = true;
//             originalRequest.headers = {};
//             console.log('Got an auth issue, refreshing!');
//             await service.signInWithToken();
//             return axios(originalRequest);
//         }
//     }
//     return Promise.reject(error);
// });

export default service;